/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_Favorite_TitleInputs */

const en_subscription_exclusive_feature_favorite_title = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favorite Sets`)
};

const ar_subscription_exclusive_feature_favorite_title = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المجموعات المفضلة`)
};

const de_subscription_exclusive_feature_favorite_title = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorzugte Sets`)
};

const es_subscription_exclusive_feature_favorite_title = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes favoritos`)
};

const fr_subscription_exclusive_feature_favorite_title = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combinaisons préférées`)
};

const it_subscription_exclusive_feature_favorite_title = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set preferiti`)
};

const ja_subscription_exclusive_feature_favorite_title = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お気に入り設定`)
};

const ko_subscription_exclusive_feature_favorite_title = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`즐겨찾기 세트`)
};

const pt_br_subscription_exclusive_feature_favorite_title = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjuntos de favoritos`)
};

const ru_subscription_exclusive_feature_favorite_title = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Любимые наборы`)
};

const th_subscription_exclusive_feature_favorite_title = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เซ็ตโปรด`)
};

const tr_subscription_exclusive_feature_favorite_title = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favori Setler`)
};

const zh_cn_subscription_exclusive_feature_favorite_title = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最爱组合`)
};

const zh_tw_subscription_exclusive_feature_favorite_title = /** @type {(inputs: Subscription_Exclusive_Feature_Favorite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最愛組合`)
};

/**
* | output |
* | --- |
* | "Favorite Sets" |
*
* @param {Subscription_Exclusive_Feature_Favorite_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_favorite_title = /** @type {((inputs?: Subscription_Exclusive_Feature_Favorite_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_Favorite_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_favorite_title(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_favorite_title(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_favorite_title(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_favorite_title(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_favorite_title(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_favorite_title(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_favorite_title(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_favorite_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_favorite_title(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_favorite_title(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_favorite_title(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_favorite_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_favorite_title(inputs)
	return zh_tw_subscription_exclusive_feature_favorite_title(inputs)
});